import { render, staticRenderFns } from "./donate.vue?vue&type=template&id=c5b8c724"
import script from "./donate.vue?vue&type=script&lang=js"
export * from "./donate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports